var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampaignwillbeinterrupted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 157.149,
    height: 141.411,
    viewBox: "0 0 157.149 141.411",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7495",
    "data-name": "Caminho 7495",
    d: "M2219.909,161.679c20.479,4.049,30.95,27.247,63.953,47.9s25.743,101.295-26.379,88.134c-49.722-12.553-52.007-11.57-84.576-10.384C2132.151,288.775,2155.06,148.923,2219.909,161.679Z",
    transform: "translate(-2152.561 -160.856)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 0.501,
    x2: 1.001,
    y2: 0.501,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9c4ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#ced6f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#e8edf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783,
    stopColor: "#f7fafd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.002,
    y1: 0.501,
    x2: 0.999,
    y2: 0.501,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009db0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#01c0ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#01dade"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    stopColor: "#02e9ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02efee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.004,
    y1: 0.499,
    x2: 0.999,
    y2: 0.499,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0,
    y1: 0.487,
    x2: 1.001,
    y2: 0.487,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -0.001,
    y1: 0.501,
    x2: 0.999,
    y2: 0.501,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -0.027,
    y1: 0.5,
    x2: 0.975,
    y2: 0.5,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -0.024,
    y1: 0.499,
    x2: 0.994,
    y2: 0.499,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    y1: 0.501,
    x2: 1,
    y2: 0.501,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb6c85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#ed7281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#f18176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#f99b63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb154"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3934c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#3f39c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618,
    stopColor: "#4e47d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#685eee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0,
    y1: 0.504,
    x2: 1,
    y2: 0.504,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7540",
    "data-name": "Caminho 7540",
    d: "M2193.069,444.664a2.47,2.47,0,0,1-2.516,2.864,3.3,3.3,0,0,1-3.211-2.864,2.47,2.47,0,0,1,2.516-2.864A3.318,3.318,0,0,1,2193.069,444.664Z",
    transform: "translate(-2187.319 -441.8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7571",
    "data-name": "Caminho 7571",
    d: "M2201.77,521.164a2.47,2.47,0,0,1-2.517,2.864,3.3,3.3,0,0,1-3.21-2.864,2.47,2.47,0,0,1,2.517-2.864A3.341,3.341,0,0,1,2201.77,521.164Z",
    transform: "translate(-2196.019 -518.3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7608",
    "data-name": "Caminho 7608",
    d: "M2206.369,560.964a2.47,2.47,0,0,1-2.517,2.864,3.3,3.3,0,0,1-3.21-2.864,2.47,2.47,0,0,1,2.516-2.864A3.3,3.3,0,0,1,2206.369,560.964Z",
    transform: "translate(-2200.619 -558.1)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -32.696,
    y1: 0.5,
    x2: -31.696,
    y2: 0.5,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -119.161,
    y1: 0.5,
    x2: -118.162,
    y2: 0.5,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -12.925,
    y1: 0.5,
    x2: -11.925,
    y2: 0.5,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -66.426,
    y1: 0.5,
    x2: -65.426,
    y2: 0.5,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -204.254,
    y1: 0.499,
    x2: -203.253,
    y2: 0.499,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 0,
    y1: 0.502,
    x2: 0.998,
    y2: 0.502,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 0.001,
    y1: 0.502,
    x2: 0.999,
    y2: 0.502,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -76.317,
    y1: 0.117,
    x2: -77.5,
    y2: 0.803,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb2040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#f53d5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#ef5772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#ec6680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb6c85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -0.082,
    y1: -0.937,
    x2: 1.031,
    y2: -0.937,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Campaign_will_be_interrupted",
    "data-name": "Campaign will be interrupted",
    transform: "translate(-2133.2 -151.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6721",
    "data-name": "Grupo 6721",
    transform: "translate(2138.8 151.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6718",
    "data-name": "Grupo 6718",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6605",
    "data-name": "Grupo 6605",
    transform: "translate(0 2.732)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7480",
    "data-name": "Caminho 7480",
    d: "M2219.909,161.679c20.479,4.049,30.95,27.247,63.953,47.9s25.743,101.295-26.379,88.134c-49.722-12.553-52.007-11.57-84.576-10.384C2132.151,288.775,2155.06,148.923,2219.909,161.679Z",
    transform: "translate(-2152.561 -160.856)",
    fill: "#dcddf9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6716",
    "data-name": "Grupo 6716",
    transform: "translate(0 2.732)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6715",
    "data-name": "Grupo 6715",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6698",
    "data-name": "Grupo 6698",
    transform: "translate(-27.149 14.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6608",
    "data-name": "Grupo 6608",
    transform: "translate(22.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6606",
    "data-name": "Grupo 6606"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7481",
    "data-name": "Caminho 7481",
    d: "M2147.595,237.849V232.9h8.186V209.3h2.256v23.6h8.822v4.946h4.715V336.83H2137.5V237.849Z",
    transform: "translate(-2137.5 -209.3)",
    fill: "#e8e8f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6607",
    "data-name": "Grupo 6607",
    transform: "translate(0 28.549)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2005",
    "data-name": "Ret\\xE2ngulo 2005",
    width: 4.715,
    height: 89.06,
    fill: "#d6d7f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6610",
    "data-name": "Grupo 6610",
    transform: "translate(39.83 52.123)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2006",
    "data-name": "Ret\\xE2ngulo 2006",
    width: 34.102,
    height: 75.407,
    opacity: 0.22,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6609",
    "data-name": "Grupo 6609"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2007",
    "data-name": "Ret\\xE2ngulo 2007",
    width: 4.715,
    height: 75.407,
    fill: "#d6d7f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6613",
    "data-name": "Grupo 6613",
    transform: "translate(130.307 52.123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6611",
    "data-name": "Grupo 6611"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2008",
    "data-name": "Ret\\xE2ngulo 2008",
    width: 34.102,
    height: 75.407,
    fill: "#e8e8f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6612",
    "data-name": "Grupo 6612"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2009",
    "data-name": "Ret\\xE2ngulo 2009",
    width: 4.715,
    height: 75.407,
    fill: "#d6d7f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6641",
    "data-name": "Grupo 6641",
    transform: "translate(72.977 16.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6614",
    "data-name": "Grupo 6614"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2010",
    "data-name": "Ret\\xE2ngulo 2010",
    width: 45.73,
    height: 111.274,
    fill: "#e8e8f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6615",
    "data-name": "Grupo 6615"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2011",
    "data-name": "Ret\\xE2ngulo 2011",
    width: 4.715,
    height: 111.274,
    fill: "#d6d7f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6616",
    "data-name": "Grupo 6616",
    transform: "translate(33.784 5.322)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2012",
    "data-name": "Ret\\xE2ngulo 2012",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6617",
    "data-name": "Grupo 6617",
    transform: "translate(21.751 5.322)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2013",
    "data-name": "Ret\\xE2ngulo 2013",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6618",
    "data-name": "Grupo 6618",
    transform: "translate(33.784 16.111)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2014",
    "data-name": "Ret\\xE2ngulo 2014",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6619",
    "data-name": "Grupo 6619",
    transform: "translate(21.751 16.111)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2015",
    "data-name": "Ret\\xE2ngulo 2015",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6620",
    "data-name": "Grupo 6620",
    transform: "translate(9.719 16.111)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2016",
    "data-name": "Ret\\xE2ngulo 2016",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6621",
    "data-name": "Grupo 6621",
    transform: "translate(33.784 26.929)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2017",
    "data-name": "Ret\\xE2ngulo 2017",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6622",
    "data-name": "Grupo 6622",
    transform: "translate(9.719 26.929)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2018",
    "data-name": "Ret\\xE2ngulo 2018",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6623",
    "data-name": "Grupo 6623",
    transform: "translate(21.751 32.309)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2019",
    "data-name": "Ret\\xE2ngulo 2019",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6624",
    "data-name": "Grupo 6624",
    transform: "translate(33.784 37.718)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2020",
    "data-name": "Ret\\xE2ngulo 2020",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6625",
    "data-name": "Grupo 6625",
    transform: "translate(21.751 43.098)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2021",
    "data-name": "Ret\\xE2ngulo 2021",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6626",
    "data-name": "Grupo 6626",
    transform: "translate(33.784 48.507)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2022",
    "data-name": "Ret\\xE2ngulo 2022",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6627",
    "data-name": "Grupo 6627",
    transform: "translate(9.719 48.507)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2023",
    "data-name": "Ret\\xE2ngulo 2023",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6628",
    "data-name": "Grupo 6628",
    transform: "translate(33.784 58.486)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2024",
    "data-name": "Ret\\xE2ngulo 2024",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6629",
    "data-name": "Grupo 6629",
    transform: "translate(21.751 58.486)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2025",
    "data-name": "Ret\\xE2ngulo 2025",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6630",
    "data-name": "Grupo 6630",
    transform: "translate(33.784 69.275)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2026",
    "data-name": "Ret\\xE2ngulo 2026",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6631",
    "data-name": "Grupo 6631",
    transform: "translate(21.751 69.275)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2027",
    "data-name": "Ret\\xE2ngulo 2027",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6632",
    "data-name": "Grupo 6632",
    transform: "translate(9.719 69.275)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2028",
    "data-name": "Ret\\xE2ngulo 2028",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6633",
    "data-name": "Grupo 6633",
    transform: "translate(33.784 80.064)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2029",
    "data-name": "Ret\\xE2ngulo 2029",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6634",
    "data-name": "Grupo 6634",
    transform: "translate(9.719 80.064)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2030",
    "data-name": "Ret\\xE2ngulo 2030",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6635",
    "data-name": "Grupo 6635",
    transform: "translate(21.751 85.473)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2031",
    "data-name": "Ret\\xE2ngulo 2031",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6636",
    "data-name": "Grupo 6636",
    transform: "translate(9.719 85.473)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2032",
    "data-name": "Ret\\xE2ngulo 2032",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6637",
    "data-name": "Grupo 6637",
    transform: "translate(33.784 90.882)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2033",
    "data-name": "Ret\\xE2ngulo 2033",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6638",
    "data-name": "Grupo 6638",
    transform: "translate(21.751 96.262)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2034",
    "data-name": "Ret\\xE2ngulo 2034",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6639",
    "data-name": "Grupo 6639",
    transform: "translate(33.784 101.671)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2035",
    "data-name": "Ret\\xE2ngulo 2035",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6640",
    "data-name": "Grupo 6640",
    transform: "translate(9.719 101.671)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2036",
    "data-name": "Ret\\xE2ngulo 2036",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6669",
    "data-name": "Grupo 6669",
    transform: "translate(153.794 24.557)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6642",
    "data-name": "Grupo 6642"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2037",
    "data-name": "Ret\\xE2ngulo 2037",
    width: 44.834,
    height: 102.973,
    fill: "#e8e8f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6643",
    "data-name": "Grupo 6643"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2038",
    "data-name": "Ret\\xE2ngulo 2038",
    width: 4.628,
    height: 102.973,
    fill: "#d6d7f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6644",
    "data-name": "Grupo 6644",
    transform: "translate(33.119 4.917)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2039",
    "data-name": "Ret\\xE2ngulo 2039",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6645",
    "data-name": "Grupo 6645",
    transform: "translate(21.318 4.917)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2040",
    "data-name": "Ret\\xE2ngulo 2040",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6646",
    "data-name": "Grupo 6646",
    transform: "translate(33.119 14.925)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2041",
    "data-name": "Ret\\xE2ngulo 2041",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6647",
    "data-name": "Grupo 6647",
    transform: "translate(21.318 14.925)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2042",
    "data-name": "Ret\\xE2ngulo 2042",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6648",
    "data-name": "Grupo 6648",
    transform: "translate(9.516 14.925)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2043",
    "data-name": "Ret\\xE2ngulo 2043",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6649",
    "data-name": "Grupo 6649",
    transform: "translate(33.119 24.904)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2044",
    "data-name": "Ret\\xE2ngulo 2044",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6650",
    "data-name": "Grupo 6650",
    transform: "translate(9.516 24.904)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2045",
    "data-name": "Ret\\xE2ngulo 2045",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6651",
    "data-name": "Grupo 6651",
    transform: "translate(21.318 29.908)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2046",
    "data-name": "Ret\\xE2ngulo 2046",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6652",
    "data-name": "Grupo 6652",
    transform: "translate(33.119 34.883)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2047",
    "data-name": "Ret\\xE2ngulo 2047",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6653",
    "data-name": "Grupo 6653",
    transform: "translate(21.318 39.887)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2048",
    "data-name": "Ret\\xE2ngulo 2048",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6654",
    "data-name": "Grupo 6654",
    transform: "translate(33.119 44.891)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2049",
    "data-name": "Ret\\xE2ngulo 2049",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6655",
    "data-name": "Grupo 6655",
    transform: "translate(9.516 44.891)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2050",
    "data-name": "Ret\\xE2ngulo 2050",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6656",
    "data-name": "Grupo 6656",
    transform: "translate(33.119 54.118)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2051",
    "data-name": "Ret\\xE2ngulo 2051",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6657",
    "data-name": "Grupo 6657",
    transform: "translate(21.318 54.118)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2052",
    "data-name": "Ret\\xE2ngulo 2052",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6658",
    "data-name": "Grupo 6658",
    transform: "translate(33.119 64.098)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2053",
    "data-name": "Ret\\xE2ngulo 2053",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6659",
    "data-name": "Grupo 6659",
    transform: "translate(21.318 64.098)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2054",
    "data-name": "Ret\\xE2ngulo 2054",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6660",
    "data-name": "Grupo 6660",
    transform: "translate(9.516 64.098)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2055",
    "data-name": "Ret\\xE2ngulo 2055",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6661",
    "data-name": "Grupo 6661",
    transform: "translate(33.119 74.106)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2056",
    "data-name": "Ret\\xE2ngulo 2056",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6662",
    "data-name": "Grupo 6662",
    transform: "translate(9.516 74.106)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2057",
    "data-name": "Ret\\xE2ngulo 2057",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6663",
    "data-name": "Grupo 6663",
    transform: "translate(21.318 79.11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2058",
    "data-name": "Ret\\xE2ngulo 2058",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6664",
    "data-name": "Grupo 6664",
    transform: "translate(9.516 79.11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2059",
    "data-name": "Ret\\xE2ngulo 2059",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6665",
    "data-name": "Grupo 6665",
    transform: "translate(33.119 84.085)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2060",
    "data-name": "Ret\\xE2ngulo 2060",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6666",
    "data-name": "Grupo 6666",
    transform: "translate(21.318 89.089)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2061",
    "data-name": "Ret\\xE2ngulo 2061",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6667",
    "data-name": "Grupo 6667",
    transform: "translate(33.119 94.093)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2062",
    "data-name": "Ret\\xE2ngulo 2062",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6668",
    "data-name": "Grupo 6668",
    transform: "translate(9.516 94.093)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2063",
    "data-name": "Ret\\xE2ngulo 2063",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6697",
    "data-name": "Grupo 6697",
    transform: "translate(0 57.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6670",
    "data-name": "Grupo 6670"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2064",
    "data-name": "Ret\\xE2ngulo 2064",
    width: 28.867,
    height: 70.23,
    fill: "#e8e8f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6671",
    "data-name": "Grupo 6671"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2065",
    "data-name": "Ret\\xE2ngulo 2065",
    width: 2.979,
    height: 70.23,
    fill: "#d6d7f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6672",
    "data-name": "Grupo 6672",
    transform: "translate(21.318 3.355)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2066",
    "data-name": "Ret\\xE2ngulo 2066",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6673",
    "data-name": "Grupo 6673",
    transform: "translate(13.739 3.355)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2067",
    "data-name": "Ret\\xE2ngulo 2067",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6674",
    "data-name": "Grupo 6674",
    transform: "translate(21.318 10.182)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2068",
    "data-name": "Ret\\xE2ngulo 2068",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6675",
    "data-name": "Grupo 6675",
    transform: "translate(13.739 10.182)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2069",
    "data-name": "Ret\\xE2ngulo 2069",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6676",
    "data-name": "Grupo 6676",
    transform: "translate(6.132 10.182)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2070",
    "data-name": "Ret\\xE2ngulo 2070",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6677",
    "data-name": "Grupo 6677",
    transform: "translate(21.318 16.979)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2071",
    "data-name": "Ret\\xE2ngulo 2071",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6678",
    "data-name": "Grupo 6678",
    transform: "translate(6.132 16.979)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2072",
    "data-name": "Ret\\xE2ngulo 2072",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6679",
    "data-name": "Grupo 6679",
    transform: "translate(13.739 20.392)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2073",
    "data-name": "Ret\\xE2ngulo 2073",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6680",
    "data-name": "Grupo 6680",
    transform: "translate(21.318 23.805)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2074",
    "data-name": "Ret\\xE2ngulo 2074",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6681",
    "data-name": "Grupo 6681",
    transform: "translate(13.739 27.218)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2075",
    "data-name": "Ret\\xE2ngulo 2075",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6682",
    "data-name": "Grupo 6682",
    transform: "translate(21.318 30.603)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2076",
    "data-name": "Ret\\xE2ngulo 2076",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6683",
    "data-name": "Grupo 6683",
    transform: "translate(6.132 30.603)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2077",
    "data-name": "Ret\\xE2ngulo 2077",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6684",
    "data-name": "Grupo 6684",
    transform: "translate(21.318 36.908)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2078",
    "data-name": "Ret\\xE2ngulo 2078",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6685",
    "data-name": "Grupo 6685",
    transform: "translate(13.739 36.908)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2079",
    "data-name": "Ret\\xE2ngulo 2079",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6686",
    "data-name": "Grupo 6686",
    transform: "translate(21.318 43.734)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2080",
    "data-name": "Ret\\xE2ngulo 2080",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6687",
    "data-name": "Grupo 6687",
    transform: "translate(13.739 43.734)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2081",
    "data-name": "Ret\\xE2ngulo 2081",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6688",
    "data-name": "Grupo 6688",
    transform: "translate(6.132 43.734)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2082",
    "data-name": "Ret\\xE2ngulo 2082",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6689",
    "data-name": "Grupo 6689",
    transform: "translate(21.318 50.532)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2083",
    "data-name": "Ret\\xE2ngulo 2083",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6690",
    "data-name": "Grupo 6690",
    transform: "translate(6.132 50.532)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2084",
    "data-name": "Ret\\xE2ngulo 2084",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6691",
    "data-name": "Grupo 6691",
    transform: "translate(13.739 53.945)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2085",
    "data-name": "Ret\\xE2ngulo 2085",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6692",
    "data-name": "Grupo 6692",
    transform: "translate(6.132 53.945)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2086",
    "data-name": "Ret\\xE2ngulo 2086",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6693",
    "data-name": "Grupo 6693",
    transform: "translate(21.318 57.358)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2087",
    "data-name": "Ret\\xE2ngulo 2087",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6694",
    "data-name": "Grupo 6694",
    transform: "translate(13.739 60.771)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2088",
    "data-name": "Ret\\xE2ngulo 2088",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6695",
    "data-name": "Grupo 6695",
    transform: "translate(21.318 64.155)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2089",
    "data-name": "Ret\\xE2ngulo 2089",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6696",
    "data-name": "Grupo 6696",
    transform: "translate(6.132 64.155)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2090",
    "data-name": "Ret\\xE2ngulo 2090",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6707",
    "data-name": "Grupo 6707",
    transform: "translate(-59.834 -19.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6700",
    "data-name": "Grupo 6700",
    transform: "translate(0 1.302)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2091",
    "data-name": "Ret\\xE2ngulo 2091",
    width: 138.984,
    height: 158.45,
    transform: "translate(1.533 1.822)",
    fill: "#fff",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2092",
    "data-name": "Ret\\xE2ngulo 2092",
    width: 3.037,
    height: 162.326,
    transform: "translate(138.984 0.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7482",
    "data-name": "Caminho 7482",
    d: "M2089.889,264.665H2079.1L2136.921,110.9h10.789Z",
    transform: "translate(-2040.514 -107.255)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7483",
    "data-name": "Caminho 7483",
    d: "M2037.309,264.665H2031.9L2089.721,110.9h5.409Z",
    transform: "translate(-2006.967 -107.255)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7484",
    "data-name": "Caminho 7484",
    d: "M2259.98,305.249h-5.38L2304.148,168v11.049Z",
    transform: "translate(-2165.251 -147.839)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2093",
    "data-name": "Ret\\xE2ngulo 2093",
    width: 142.021,
    height: 4.194,
    transform: "translate(0 158.479)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6699",
    "data-name": "Grupo 6699",
    transform: "translate(92.675 0.839)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2094",
    "data-name": "Ret\\xE2ngulo 2094",
    width: 3.037,
    height: 160.678,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2095",
    "data-name": "Ret\\xE2ngulo 2095",
    width: 135.918,
    height: 1.273,
    transform: "translate(3.066 157.409)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2096",
    "data-name": "Ret\\xE2ngulo 2096",
    width: 142.021,
    height: 3.616,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2097",
    "data-name": "Ret\\xE2ngulo 2097",
    width: 135.976,
    height: 1.273,
    transform: "translate(3.037 3.645)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6703",
    "data-name": "Grupo 6703",
    transform: "translate(139.013)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2098",
    "data-name": "Ret\\xE2ngulo 2098",
    width: 138.984,
    height: 158.45,
    transform: "translate(2.227)",
    fill: "#fff",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6701",
    "data-name": "Grupo 6701",
    transform: "translate(0 1.331)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2099",
    "data-name": "Ret\\xE2ngulo 2099",
    width: 3.037,
    height: 162.326,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7485",
    "data-name": "Caminho 7485",
    d: "M2486.989,264.665H2476.2L2534.021,110.9h10.789Z",
    transform: "translate(-2461.766 -105.954)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7486",
    "data-name": "Caminho 7486",
    d: "M2434.38,264.665H2429L2486.821,110.9h5.38Z",
    transform: "translate(-2428.219 -105.954)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7487",
    "data-name": "Caminho 7487",
    d: "M2740.48,305.249h-5.38L2784.678,168v11.049Z",
    transform: "translate(-2645.78 -146.538)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6702",
    "data-name": "Grupo 6702",
    transform: "translate(46.309 2.14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2100",
    "data-name": "Ret\\xE2ngulo 2100",
    width: 3.037,
    height: 160.678,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2101",
    "data-name": "Ret\\xE2ngulo 2101",
    width: 142.021,
    height: 4.194,
    transform: "translate(0 159.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2102",
    "data-name": "Ret\\xE2ngulo 2102",
    width: 3.037,
    height: 160.678,
    transform: "translate(92.646 2.14)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2103",
    "data-name": "Ret\\xE2ngulo 2103",
    width: 135.918,
    height: 1.273,
    transform: "translate(3.037 158.711)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2104",
    "data-name": "Ret\\xE2ngulo 2104",
    width: 142.021,
    height: 3.616,
    transform: "translate(0 1.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2105",
    "data-name": "Ret\\xE2ngulo 2105",
    width: 135.976,
    height: 1.273,
    transform: "translate(3.008 4.946)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6704",
    "data-name": "Grupo 6704",
    transform: "translate(0 29.908)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2106",
    "data-name": "Ret\\xE2ngulo 2106",
    width: 286.009,
    height: 1.822,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6705",
    "data-name": "Grupo 6705",
    transform: "translate(0 78.242)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2107",
    "data-name": "Ret\\xE2ngulo 2107",
    width: 286.009,
    height: 1.822,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6706",
    "data-name": "Grupo 6706",
    transform: "translate(0 126.604)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2108",
    "data-name": "Ret\\xE2ngulo 2108",
    width: 286.009,
    height: 1.822,
    fill: "#f5f5ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6714",
    "data-name": "Grupo 6714",
    transform: "translate(37.382 -6.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6708",
    "data-name": "Grupo 6708",
    transform: "translate(10.124 19.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7488",
    "data-name": "Caminho 7488",
    d: "M2327.213,213.713A10.425,10.425,0,0,1,2316.8,203.3h.492a9.921,9.921,0,1,0,19.842,0h.492A10.444,10.444,0,0,1,2327.213,213.713Z",
    transform: "translate(-2316.8 -203.3)",
    fill: "#e8e8f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6709",
    "data-name": "Grupo 6709",
    transform: "translate(7.26 11.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7489",
    "data-name": "Caminho 7489",
    d: "M2320.032,175.1,2306.9,186h28.954Z",
    transform: "translate(-2306.9 -175.1)",
    fill: "#d6d7f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7490",
    "data-name": "Caminho 7490",
    d: "M2295.655,207.4,2281.8,252.118h40.321l-13.1-44.718Z",
    transform: "translate(-2281.8 -187.008)",
    opacity: 0.22,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6710",
    "data-name": "Grupo 6710",
    transform: "translate(19.785)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2109",
    "data-name": "Ret\\xE2ngulo 2109",
    width: 1.273,
    height: 14.405,
    fill: "#e8e8f9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7491",
    "data-name": "Caminho 7491",
    d: "M2349.281,184.728H2345V181.6a1.494,1.494,0,0,1,1.5-1.5h1.244a1.494,1.494,0,0,1,1.5,1.5v3.124Z",
    transform: "translate(-2326.72 -167.604)",
    fill: "#f4bf62"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6711",
    "data-name": "Grupo 6711",
    transform: "translate(17.876 19.814)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_652",
    "data-name": "Elipse 652",
    cx: 2.488,
    cy: 2.488,
    r: 2.488,
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7492",
    "data-name": "Caminho 7492",
    d: "M2347.593,216.172a2.133,2.133,0,0,1-1.562-1.186c-.058-.231-.405-.116-.347.087a2.362,2.362,0,0,0,1.793,1.446C2347.738,216.548,2347.825,216.2,2347.593,216.172Z",
    transform: "translate(-2327.201 -192.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6712",
    "data-name": "Grupo 6712",
    transform: "translate(5.901 11.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7493",
    "data-name": "Caminho 7493",
    d: "M2316.691,175.1,2302.2,186h28.954Z",
    transform: "translate(-2302.2 -175.1)",
    fill: "#e8e8f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6713",
    "data-name": "Grupo 6713",
    transform: "translate(19.033 9.719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7494",
    "data-name": "Caminho 7494",
    d: "M2349.538,173.19h-1.186a.766.766,0,0,1-.752-.752v-1.186a.766.766,0,0,1,.752-.752h1.186a.766.766,0,0,1,.752.752v1.186A.747.747,0,0,1,2349.538,173.19Z",
    transform: "translate(-2347.6 -170.5)",
    fill: "#d6d7f2"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6717",
    "data-name": "Grupo 6717",
    transform: "translate(108.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7496",
    "data-name": "Caminho 7496",
    d: "M2542.165,189.009c-9.6-7.665-17.615-21-13.074-33.871s13.97,11.078,21.52,19.061C2561.573,185.741,2562.3,205,2542.165,189.009Z",
    transform: "translate(-2527.785 -151.41)",
    fill: "#dcddf9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6726",
    "data-name": "Grupo 6726",
    transform: "translate(2228.528 238.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6724",
    "data-name": "Grupo 6724"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7497",
    "data-name": "Caminho 7497",
    d: "M2511.995,465.57a4.375,4.375,0,0,0,2.516-.839,20.694,20.694,0,0,1-.376,4.628c-.983,1.591-3.731,4.512-3.558,4.512a8.39,8.39,0,0,0,2.2-.521,17.9,17.9,0,0,1-1.677,2.748c-1.331,1.764-3.211,3.182-3.934,5.351-.029.058-.058.087-.087.087-.029.116-.145.2-.26.116-3.587-3.384-4.223-8.562-4.744-13.219a5.141,5.141,0,0,1-.058-.665,14.271,14.271,0,0,0,3.3,2.574c.174.087-2.227-3.76-3.413-5.554a9.926,9.926,0,0,1,.607-3.3,27.874,27.874,0,0,1,3.674-6.277c.058-.087.115-.145.173-.231a10.016,10.016,0,0,0,1.533,2.777,32.451,32.451,0,0,0-.491-4.194c.347-.434.694-.868,1.07-1.3.492-.55,1.07-1.5,1.909-1.388s2.719,3.529,2.979,4.483c.115.4.2.839.289,1.273.029.173.087.376.116.55.318,1.707.492,3.471.636,5.178l-.174.26C2513.5,463.661,2511.821,465.57,2511.995,465.57Z",
    transform: "translate(-2490.583 -450.867)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7498",
    "data-name": "Caminho 7498",
    d: "M2517.01,474.845a8.607,8.607,0,0,0,4.4-2.545c.2-.174-.058-.492-.232-.318a8.526,8.526,0,0,1-4.136,2.43c.376-2.632.81-5.235,1.331-7.868.058-.26-.347-.318-.4-.058-.694,3.442-1.244,6.942-1.678,10.413a17.784,17.784,0,0,1-2.343-4.686c-.087-.26-.463-.087-.376.145a17.35,17.35,0,0,0,2.516,4.946.159.159,0,0,0,.144.087c-.086.752-.173,1.533-.26,2.285a10.6,10.6,0,0,1-1.736-3.037c-.087-.231-.463-.087-.376.145a11.138,11.138,0,0,0,1.967,3.355c.029.029.058.058.086.058-.26,2.516-.463,5.033-.578,7.578,0,.029-.029.058-.029.087q-.086,1.388-.087,2.777c-.029.607-.029,1.215-.058,1.822a.221.221,0,0,0,.058.145,89.726,89.726,0,0,0,2.14,16.892c.145-.029.26-.058.405-.087a83.54,83.54,0,0,1-2.141-19.119c.029-.694.058-1.359.087-2.054a.136.136,0,0,0,.174-.029,6.373,6.373,0,0,0,1.851-1.88c.145-.2-.174-.463-.318-.26a6.962,6.962,0,0,1-1.678,1.764c.231-4.339.636-8.677,1.273-12.987Z",
    transform: "translate(-2498.866 -461.848)",
    fill: "#009db0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7499",
    "data-name": "Caminho 7499",
    d: "M2466.887,507.659a4.183,4.183,0,0,1-2.372.2,15.723,15.723,0,0,0,1.649,3.355c1.3.868,4.483,2.169,4.31,2.227a9.568,9.568,0,0,1-2.025.347,12.027,12.027,0,0,0,2.227,1.5c1.649.9,3.674,1.331,4.917,2.719.029.029.058.058.087.058a.149.149,0,0,0,.26,0c2.054-3.731,1.1-7.81.2-11.483a3.481,3.481,0,0,0-.145-.521,12.331,12.331,0,0,1-2.054,3.008c-.115.116.81-3.558,1.3-5.293a7.729,7.729,0,0,0-1.475-2.285,20.921,20.921,0,0,0-4.946-3.5,1.744,1.744,0,0,0-.231-.116,8.288,8.288,0,0,1-.492,2.6,22.746,22.746,0,0,1-.81-3.3c-.434-.2-.839-.434-1.273-.607-.578-.26-1.359-.781-2.025-.4s-1.3,3.529-1.215,4.339c.029.347.087.694.116,1.041a2.256,2.256,0,0,1,.058.463,38.491,38.491,0,0,0,.955,4.107c.087.058.144.087.231.145A27.09,27.09,0,0,1,2466.887,507.659Z",
    transform: "translate(-2462.772 -482.976)",
    fill: "#009db0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6722",
    "data-name": "Grupo 6722",
    transform: "translate(0.124 16.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7500",
    "data-name": "Caminho 7500",
    d: "M2483.157,539.53a63.884,63.884,0,0,0-3.095-13.392.088.088,0,0,0,0-.116c-.174-.463-.376-.9-.578-1.331-.29-.694-.579-1.359-.9-2.054,0-.029-.029-.029-.058-.058-.839-1.851-1.735-3.673-2.69-5.5l.058-.058a8.739,8.739,0,0,0,.694-3.182c0-.2-.347-.2-.376,0a9.018,9.018,0,0,1-.578,2.864c-.289-.55-.579-1.1-.9-1.649.058-.029.087-.058.087-.116a13.66,13.66,0,0,0,.694-4.541c0-.2-.376-.2-.376,0a13.868,13.868,0,0,1-.607,4.31c-1.388-2.488-2.864-4.917-4.455-7.289-.116-.174-.434,0-.318.174,1.186,1.793,2.343,3.616,3.413,5.467a8.362,8.362,0,0,1-4.223-.463c-.2-.058-.318.26-.116.318a8.437,8.437,0,0,0,4.483.463h0a102.339,102.339,0,0,1,4.831,9.372,6.018,6.018,0,0,1-1.938-.752c-.174-.116-.376.174-.2.289a6.043,6.043,0,0,0,2.112.81.217.217,0,0,0,.145-.029c.231.492.434,1.012.665,1.5a59.6,59.6,0,0,1,3.731,15.07A1.3,1.3,0,0,1,2483.157,539.53Z",
    transform: "translate(-2467.133 -507.351)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7501",
    "data-name": "Caminho 7501",
    d: "M2466.353,516.315a9.664,9.664,0,0,1-3.153-1.215,2.239,2.239,0,0,1,.058.463,9.278,9.278,0,0,0,2.95,1.1C2466.469,516.691,2466.556,516.344,2466.353,516.315Z",
    transform: "translate(-2463.2 -512.859)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7502",
    "data-name": "Caminho 7502",
    d: "M2545.957,523.3c-.029,1.446-3.384,2.169-4.454,2.545-2.372.868-4.686,1.764-6.421,3.673a76.606,76.606,0,0,0-5.612,7.318.432.432,0,0,1-.434.174,5.483,5.483,0,0,1-.492-1.07c-.607-1.5-1.562-4.281-1.331-5.843a10.179,10.179,0,0,1,1.07-3.153,2.766,2.766,0,0,0,.665,1.331,26.864,26.864,0,0,0,.376-2.921,4.446,4.446,0,0,1,.492-.55,11.794,11.794,0,0,1,1.244-1.157c.087-.087.2-.145.29-.231.376-.26.752-.521,1.128-.752.116-.058.2-.116.318-.174a10.1,10.1,0,0,1,1.128-.55,7.541,7.541,0,0,0,.636,2.083,14.406,14.406,0,0,0,.26-2.43,8.418,8.418,0,0,1,1.128-.347,6.562,6.562,0,0,0,.463,1.331,6.373,6.373,0,0,0,.723-1.62,15.383,15.383,0,0,1,3.615-.289,1.186,1.186,0,0,1,.318.029c.318.029.636.058.955.116,1.157.174,3.9.926,3.934,2.488Z",
    transform: "translate(-2508.548 -500.465)",
    fill: "#009db0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6723",
    "data-name": "Grupo 6723",
    transform: "translate(19.698 22.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7503",
    "data-name": "Caminho 7503",
    d: "M2535.624,533.547c-2.864,2.835-3.76,8.012-3.934,9.487a5.871,5.871,0,0,0-.579,1.909,41.733,41.733,0,0,0-.174,7.115c.029.781.058,1.533.087,2.314.145-.029.26-.058.4-.087-.029-.492-.058-.983-.058-1.446-.058-2.112-.058-4.194.029-6.306a9.233,9.233,0,0,1,.579-3.182.227.227,0,0,0,.116-.116,81.6,81.6,0,0,1,5.611-7.318c1.764-1.909,4.049-2.777,6.421-3.673,1.07-.4,4.426-1.1,4.454-2.545C2544.1,530.25,2538.921,530.307,2535.624,533.547Z",
    transform: "translate(-2530.872 -528.919)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7504",
    "data-name": "Caminho 7504",
    d: "M2545.754,530.24a9.392,9.392,0,0,1-.058-3.24c-.115.058-.2.116-.318.174a9.452,9.452,0,0,0,.087,3.124C2545.493,530.5,2545.783,530.413,2545.754,530.24Z",
    transform: "translate(-2541.118 -527)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7505",
    "data-name": "Caminho 7505",
    d: "M2541.395,533.093a10.893,10.893,0,0,1-.4-2.893,2.028,2.028,0,0,0-.29.231,12.632,12.632,0,0,0,.405,2.748C2541.134,533.353,2541.423,533.295,2541.395,533.093Z",
    transform: "translate(-2537.857 -529.274)",
    fill: "url(#linear-gradient-9)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6725",
    "data-name": "Grupo 6725",
    transform: "translate(6.979 41.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7506",
    "data-name": "Caminho 7506",
    d: "M2508,597.307a10.882,10.882,0,0,1-.231,2.2,10.581,10.581,0,0,1-4.107,6.306h-12.322a10.579,10.579,0,0,1-4.107-6.306,11.126,11.126,0,0,1-.231-2.2,9.881,9.881,0,0,1,.26-2.285,12.159,12.159,0,0,1,.578-1.822h19.351a9.574,9.574,0,0,1,.578,1.822A11.993,11.993,0,0,1,2508,597.307Z",
    transform: "translate(-2486.971 -593.2)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7507",
    "data-name": "Caminho 7507",
    d: "M2518.661,597.307a10.882,10.882,0,0,1-.231,2.2,10.579,10.579,0,0,1-4.107,6.306H2502c16.082.81,15.822-12.611,15.822-12.611a9.54,9.54,0,0,1,.579,1.822A10.065,10.065,0,0,1,2518.661,597.307Z",
    transform: "translate(-2497.632 -593.2)",
    fill: "#ff6b77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7508",
    "data-name": "Caminho 7508",
    d: "M2491.586,593.3h-3.847a12.185,12.185,0,0,0-.578,1.822,9.881,9.881,0,0,0-.26,2.285,10.881,10.881,0,0,0,.231,2.2,10.58,10.58,0,0,0,4.107,6.306h1.707C2490.921,604.407,2489.966,597.552,2491.586,593.3Z",
    transform: "translate(-2486.9 -593.271)",
    fill: "#fda798"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6762",
    "data-name": "Grupo 6762",
    transform: "translate(2133.56 227.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6729",
    "data-name": "Grupo 6729",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7509",
    "data-name": "Caminho 7509",
    d: "M2146.87,479.739h82.552a3.775,3.775,0,0,0,3.818-4.454l-7.318-56.23a5.284,5.284,0,0,0-5.062-4.454h-82.552a3.775,3.775,0,0,0-3.818,4.454l7.318,56.259A5.281,5.281,0,0,0,2146.87,479.739Z",
    transform: "translate(-2134.445 -414.6)",
    fill: "#312da4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7510",
    "data-name": "Caminho 7510",
    d: "M2247.821,475.574H2165.3a5.284,5.284,0,0,1-5.062-4.454l-1.244-8.793-6.1-43.272a3.775,3.775,0,0,1,3.818-4.454h82.552a5.284,5.284,0,0,1,5.062,4.454l1.533,10.934,5.785,41.1A3.786,3.786,0,0,1,2247.821,475.574Z",
    transform: "translate(-2147.523 -414.6)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7511",
    "data-name": "Caminho 7511",
    d: "M2253.8,479h-76.073a4.882,4.882,0,0,1-4.686-4.107l-1.07-7.636-5.669-40.35a3.5,3.5,0,0,1,3.529-4.107H2245.9a4.882,4.882,0,0,1,4.686,4.107l1.244,8.851,5.5,39.135A3.485,3.485,0,0,1,2253.8,479Z",
    transform: "translate(-2157.058 -420.428)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6727",
    "data-name": "Grupo 6727",
    transform: "translate(20.986 53.54)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2110",
    "data-name": "Ret\\xE2ngulo 2110",
    width: 9.343,
    height: 2.083,
    transform: "translate(99.039)",
    fill: "#312da4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2111",
    "data-name": "Ret\\xE2ngulo 2111",
    width: 9.343,
    height: 2.083,
    transform: "translate(88.047)",
    fill: "#312da4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2112",
    "data-name": "Ret\\xE2ngulo 2112",
    width: 9.343,
    height: 2.083,
    transform: "translate(77.027)",
    fill: "#312da4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2113",
    "data-name": "Ret\\xE2ngulo 2113",
    width: 31.007,
    height: 2.083,
    transform: "translate(44.371)",
    fill: "#312da4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2114",
    "data-name": "Ret\\xE2ngulo 2114",
    width: 9.343,
    height: 2.083,
    transform: "translate(33.003)",
    fill: "#312da4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2115",
    "data-name": "Ret\\xE2ngulo 2115",
    width: 9.343,
    height: 2.083,
    transform: "translate(22.012)",
    fill: "#312da4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2116",
    "data-name": "Ret\\xE2ngulo 2116",
    width: 9.343,
    height: 2.083,
    transform: "translate(10.991)",
    fill: "#312da4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2117",
    "data-name": "Ret\\xE2ngulo 2117",
    width: 9.343,
    height: 2.083,
    fill: "#312da4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6728",
    "data-name": "Grupo 6728",
    transform: "translate(12.309 55.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7512",
    "data-name": "Caminho 7512",
    d: "M2182.525,616.487h112.142a5.524,5.524,0,0,0,5.525-5.525V607H2177v3.992A5.518,5.518,0,0,0,2182.525,616.487Z",
    transform: "translate(-2177 -606.971)",
    fill: "#312da4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2118",
    "data-name": "Ret\\xE2ngulo 2118",
    width: 123.278,
    height: 3.5,
    transform: "translate(0.058)",
    fill: "url(#linear-gradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6735",
    "data-name": "Grupo 6735",
    transform: "translate(50.943 7.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6730",
    "data-name": "Grupo 6730"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7513",
    "data-name": "Caminho 7513",
    d: "M2354.749,450.56l4.715,34.1s-35.665.607-35.665.318-4.6-34.681-4.6-34.681Z",
    transform: "translate(-2316.703 -447.379)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7514",
    "data-name": "Caminho 7514",
    d: "M2311.762,440.316a1.175,1.175,0,0,0-1.186,1.359l1.1,8.793.231,1.88,3.818,30.371a1.582,1.582,0,0,0,1.533,1.359l38.47-.116a1.174,1.174,0,0,0,1.186-1.359l-5.177-41.044a1.582,1.582,0,0,0-1.533-1.359Zm4.136,12.062-.491-3.934-.347-2.777a1.174,1.174,0,0,1,1.186-1.359l30.487-.116a1.606,1.606,0,0,1,1.533,1.359l3.615,28.693a1.174,1.174,0,0,1-1.186,1.359l-30.487.116a1.605,1.605,0,0,1-1.533-1.359Z",
    transform: "translate(-2310.567 -440.2)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6731",
    "data-name": "Grupo 6731",
    transform: "translate(6.894 7.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7515",
    "data-name": "Caminho 7515",
    d: "M2346,468.41l-11.223.029a.41.41,0,0,1-.376-.4c0-.231.115-.4.289-.4l11.223-.029a.41.41,0,0,1,.376.4C2346.317,468.236,2346.2,468.41,2346,468.41Z",
    transform: "translate(-2334.4 -467.571)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7516",
    "data-name": "Caminho 7516",
    d: "M2353.3,478.11l-17.326.029a.41.41,0,0,1-.376-.4c0-.231.116-.4.29-.4l17.326-.029a.409.409,0,0,1,.376.4C2353.62,477.936,2353.5,478.11,2353.3,478.11Z",
    transform: "translate(-2335.253 -474.465)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7517",
    "data-name": "Caminho 7517",
    d: "M2401.141,468.31l-13.074.029a.41.41,0,0,1-.376-.4.33.33,0,0,1,.289-.4l13.074-.029a.41.41,0,0,1,.376.4C2401.43,468.136,2401.343,468.31,2401.141,468.31Z",
    transform: "translate(-2372.274 -467.5)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7518",
    "data-name": "Caminho 7518",
    d: "M2417.338,478.01h-6.971a.41.41,0,0,1-.376-.4.33.33,0,0,1,.29-.4h6.971a.41.41,0,0,1,.376.4C2417.627,477.836,2417.54,478.01,2417.338,478.01Z",
    transform: "translate(-2388.123 -474.394)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6732",
    "data-name": "Grupo 6732",
    transform: "translate(7.613 13.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7519",
    "data-name": "Caminho 7519",
    d: "M2396.967,487.839l11.223-.029a.33.33,0,0,0,.289-.4.433.433,0,0,0-.376-.4l-11.223.029a.33.33,0,0,0-.289.4A.433.433,0,0,0,2396.967,487.839Z",
    transform: "translate(-2379.319 -487)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7520",
    "data-name": "Caminho 7520",
    d: "M2377.067,497.639l17.326-.029a.33.33,0,0,0,.289-.4.433.433,0,0,0-.376-.4l-17.326.029a.33.33,0,0,0-.289.4A.433.433,0,0,0,2377.067,497.639Z",
    transform: "translate(-2365.175 -493.965)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7521",
    "data-name": "Caminho 7521",
    d: "M2337.267,487.939l15.649-.029a.33.33,0,0,0,.289-.4.433.433,0,0,0-.376-.4l-15.648.029a.33.33,0,0,0-.289.4A.41.41,0,0,0,2337.267,487.939Z",
    transform: "translate(-2336.887 -487.071)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7522",
    "data-name": "Caminho 7522",
    d: "M2338.467,497.81h6.971a.33.33,0,0,0,.289-.4.433.433,0,0,0-.376-.4h-6.971a.33.33,0,0,0-.289.4A.41.41,0,0,0,2338.467,497.81Z",
    transform: "translate(-2337.74 -494.108)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6733",
    "data-name": "Grupo 6733",
    transform: "translate(8.311 19.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7523",
    "data-name": "Caminho 7523",
    d: "M2350.9,507.71l-11.223.029a.41.41,0,0,1-.376-.4c0-.231.116-.4.289-.4l11.223-.029a.41.41,0,0,1,.376.4C2351.217,507.536,2351.1,507.71,2350.9,507.71Z",
    transform: "translate(-2339.3 -506.871)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7524",
    "data-name": "Caminho 7524",
    d: "M2358.193,517.41l-17.326.029a.41.41,0,0,1-.376-.4.33.33,0,0,1,.289-.4l17.326-.029a.41.41,0,0,1,.376.4C2358.511,517.236,2358.4,517.41,2358.193,517.41Z",
    transform: "translate(-2340.144 -513.765)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7525",
    "data-name": "Caminho 7525",
    d: "M2406.041,507.61l-13.074.029a.41.41,0,0,1-.376-.4.33.33,0,0,1,.289-.4l13.074-.029a.41.41,0,0,1,.376.4C2406.33,507.436,2406.244,507.61,2406.041,507.61Z",
    transform: "translate(-2377.174 -506.8)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7526",
    "data-name": "Caminho 7526",
    d: "M2422.238,517.31h-6.971a.409.409,0,0,1-.376-.4.33.33,0,0,1,.289-.4h6.971a.41.41,0,0,1,.376.4C2422.527,517.136,2422.44,517.31,2422.238,517.31Z",
    transform: "translate(-2393.024 -513.694)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6734",
    "data-name": "Grupo 6734",
    transform: "translate(9.03 24.904)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7527",
    "data-name": "Caminho 7527",
    d: "M2401.867,527.139l11.223-.029a.33.33,0,0,0,.289-.4.433.433,0,0,0-.376-.4l-11.223.029a.33.33,0,0,0-.289.4A.433.433,0,0,0,2401.867,527.139Z",
    transform: "translate(-2384.219 -526.3)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7528",
    "data-name": "Caminho 7528",
    d: "M2381.967,536.939l17.326-.029a.33.33,0,0,0,.289-.4.433.433,0,0,0-.376-.405l-17.326.029a.33.33,0,0,0-.289.4A.433.433,0,0,0,2381.967,536.939Z",
    transform: "translate(-2370.075 -533.265)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7529",
    "data-name": "Caminho 7529",
    d: "M2342.167,527.239l15.648-.029a.33.33,0,0,0,.289-.4.433.433,0,0,0-.376-.4l-15.648.029a.33.33,0,0,0-.289.4A.409.409,0,0,0,2342.167,527.239Z",
    transform: "translate(-2341.787 -526.371)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7530",
    "data-name": "Caminho 7530",
    d: "M2343.367,537.11h6.971a.33.33,0,0,0,.289-.4.433.433,0,0,0-.376-.405h-6.971a.33.33,0,0,0-.289.405A.41.41,0,0,0,2343.367,537.11Z",
    transform: "translate(-2342.64 -533.407)",
    fill: "#f7f7f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6761",
    "data-name": "Grupo 6761",
    transform: "translate(14.862 7.433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7531",
    "data-name": "Caminho 7531",
    d: "M2236.727,446.966l-25.281-.029a.991.991,0,0,1-.954-.839l-.607-4.859a.738.738,0,0,1,.752-.839l25.281.029a.991.991,0,0,1,.954.839l.607,4.859A.753.753,0,0,1,2236.727,446.966Z",
    transform: "translate(-2202.921 -440.371)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6739",
    "data-name": "Grupo 6739"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7532",
    "data-name": "Caminho 7532",
    d: "M2192.443,443.6a2.851,2.851,0,0,1-2.893,3.3,3.818,3.818,0,0,1-3.7-3.3,2.865,2.865,0,0,1,2.892-3.3A3.815,3.815,0,0,1,2192.443,443.6Z",
    transform: "translate(-2185.827 -440.299)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7533",
    "data-name": "Caminho 7533",
    d: "M2193.069,444.664a2.47,2.47,0,0,1-2.516,2.864,3.3,3.3,0,0,1-3.211-2.864,2.47,2.47,0,0,1,2.516-2.864A3.318,3.318,0,0,1,2193.069,444.664Z",
    transform: "translate(-2186.887 -441.366)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6738",
    "data-name": "Grupo 6738",
    transform: "translate(0.431 0.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6737",
    "data-name": "Grupo 6737",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7534",
    "data-name": "Caminho 7534",
    d: "M2197.075,458.2c0,.029-.029.087-.029.116a.8.8,0,0,0-.029.26v.231a1.5,1.5,0,0,0,.058.434,1.7,1.7,0,0,1-1.475-.145,1.187,1.187,0,0,0,.029-.347v-.55h1.446Z",
    transform: "translate(-2193.204 -453.456)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7535",
    "data-name": "Caminho 7535",
    d: "M2197.217,458.2c0,.029-.029.087-.029.116a.992.992,0,0,0-.029.26v.231a1.619,1.619,0,0,1-.954.145,1.064,1.064,0,0,1-.405-.174v-.55h0Z",
    transform: "translate(-2193.347 -453.456)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7536",
    "data-name": "Caminho 7536",
    d: "M2192.2,455.131s.347.607.665.55c.231-.029-.289-.781-.289-.781Z",
    transform: "translate(-2190.788 -451.111)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7537",
    "data-name": "Caminho 7537",
    d: "M2192.62,450.124s.405.781.752.954,1.331.145,1.533-.174c.318-.463-.145-2.43-.26-2.632-.115-.174-1.764-.868-2.2-.116A2.638,2.638,0,0,0,2192.62,450.124Z",
    transform: "translate(-2190.861 -446.075)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7538",
    "data-name": "Caminho 7538",
    d: "M2193.513,445.668c-.116.231-1.273-.376-2.083-.289a1.37,1.37,0,0,0-.983.926c-.174.058-.231.463-.145.781.347,1.1.926,1.3,1.041,1.273.463-.145.405-1.041.058-1.736a3.757,3.757,0,0,1,1.273,0c.2.058.607.231.81.116C2193.744,446.536,2193.773,445.813,2193.513,445.668Z",
    transform: "translate(-2189.411 -444.338)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6736",
    "data-name": "Grupo 6736",
    transform: "translate(1.203 3.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7539",
    "data-name": "Caminho 7539",
    d: "M2192.034,453.969c-.115-.116-.492-.145-.55.029-.058.289.289.752.665.521C2192.323,454.432,2192.15,454.056,2192.034,453.969Z",
    transform: "translate(-2191.478 -453.875)",
    fill: "#f5f5ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6742",
    "data-name": "Grupo 6742",
    transform: "translate(1.354 11.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7541",
    "data-name": "Caminho 7541",
    d: "M2197.13,482.7a2.851,2.851,0,0,1-2.893,3.3,3.817,3.817,0,0,1-3.7-3.3,2.85,2.85,0,0,1,2.892-3.3A3.818,3.818,0,0,1,2197.13,482.7Z",
    transform: "translate(-2190.508 -479.4)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7542",
    "data-name": "Caminho 7542",
    d: "M2197.769,483.764a2.47,2.47,0,0,1-2.517,2.864,3.3,3.3,0,0,1-3.21-2.864,2.47,2.47,0,0,1,2.516-2.864A3.318,3.318,0,0,1,2197.769,483.764Z",
    transform: "translate(-2191.582 -480.466)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6741",
    "data-name": "Grupo 6741",
    transform: "translate(1.353 1.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7543",
    "data-name": "Caminho 7543",
    d: "M2201.82,496.3c0,.029-.029.087-.029.116a.988.988,0,0,0-.029.289v.26c.029.26.058.463.058.463a1.908,1.908,0,0,1-1.62-.145,1.522,1.522,0,0,0,.029-.376V496.3h1.591Z",
    transform: "translate(-2198.749 -492.876)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7544",
    "data-name": "Caminho 7544",
    d: "M2202.033,496.3c0,.029-.029.087-.029.116a1.2,1.2,0,0,0-.029.289v.26a1.515,1.515,0,0,1-1.041.145,1.014,1.014,0,0,1-.434-.2V496.3h1.533Z",
    transform: "translate(-2198.962 -492.876)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7545",
    "data-name": "Caminho 7545",
    d: "M2198.85,490.143s.174.607.492.781,1.273.26,1.562-.116c.318-.4-.087-2.2-.2-2.372s-1.62-.81-2.025-.116A2.42,2.42,0,0,0,2198.85,490.143Z",
    transform: "translate(-2197.573 -486.979)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7546",
    "data-name": "Caminho 7546",
    d: "M2198.629,485.225c.058-.4-.145-.839-.665-.752-.087,0-.174.087-.232.087s-.145-.087-.26-.058a.3.3,0,0,0-.289.116c-.376-.26-.984-.145-.984.318a.388.388,0,0,0-.434.116.308.308,0,0,0-.029.347.253.253,0,0,0-.173.26.465.465,0,0,0,.087.26.39.39,0,0,0-.26.434.744.744,0,0,0,.2.463.457.457,0,0,0,.087.4.49.49,0,0,0,.347.2.845.845,0,0,0,.2.492c.145.2.636.4.723.347a15.01,15.01,0,0,1-.492-2.054,8.646,8.646,0,0,0,1.5-.289c.347.116.752.174.955,0C2199.149,485.658,2198.918,485.311,2198.629,485.225Z",
    transform: "translate(-2195.327 -484.461)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7547",
    "data-name": "Caminho 7547",
    d: "M2195.912,488.394c-.232-.087-.174-.4-.087-.607a.582.582,0,0,1-.318-.087.3.3,0,0,0-.145.26.466.466,0,0,0,.087.26.39.39,0,0,0-.26.434.745.745,0,0,0,.2.463.456.456,0,0,0,.087.4.49.49,0,0,0,.347.2.847.847,0,0,0,.2.492c.145.2.636.4.723.347a7.565,7.565,0,0,1-.376-1.707C2196.144,488.8,2195.883,488.626,2195.912,488.394Z",
    transform: "translate(-2195.185 -486.763)",
    fill: "#d2d2ed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6740",
    "data-name": "Grupo 6740",
    transform: "translate(0.751 2.439)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7548",
    "data-name": "Caminho 7548",
    d: "M2198.365,493.04c-.115-.116-.55-.231-.578-.058-.058.26.347.781.694.578C2198.625,493.474,2198.451,493.127,2198.365,493.04Z",
    transform: "translate(-2197.781 -492.894)",
    fill: "#f5f5ff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6749",
    "data-name": "Grupo 6749",
    transform: "translate(2.511 22.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7549",
    "data-name": "Caminho 7549",
    d: "M2201.129,520.1a2.851,2.851,0,0,1-2.893,3.3,3.818,3.818,0,0,1-3.7-3.3,2.851,2.851,0,0,1,2.892-3.3A3.841,3.841,0,0,1,2201.129,520.1Z",
    transform: "translate(-2194.508 -516.8)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7550",
    "data-name": "Caminho 7550",
    d: "M2201.77,521.164a2.47,2.47,0,0,1-2.517,2.864,3.3,3.3,0,0,1-3.21-2.864,2.47,2.47,0,0,1,2.517-2.864A3.341,3.341,0,0,1,2201.77,521.164Z",
    transform: "translate(-2195.582 -517.866)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6748",
    "data-name": "Grupo 6748",
    transform: "translate(0.437 0.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6747",
    "data-name": "Grupo 6747",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7551",
    "data-name": "Caminho 7551",
    d: "M2208.387,532.676c-.174.058.115,1.012,1.359,2.6.318.4.636-.174.492-.4-.174-.26-.868-1.359-.868-1.359S2208.734,532.56,2208.387,532.676Z",
    transform: "translate(-2204.777 -528.511)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7552",
    "data-name": "Caminho 7552",
    d: "M2208.387,532.671c-.174.058.115,1.012,1.359,2.6-.376-.955-.4-1.273-.549-1.678C2209.081,533.307,2208.734,532.555,2208.387,532.671Z",
    transform: "translate(-2204.777 -528.505)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7553",
    "data-name": "Caminho 7553",
    d: "M2209.37,533.481a.785.785,0,0,1-.2.231,1.01,1.01,0,0,1-.434.2,4.21,4.21,0,0,1-.405-.839c0-.029-.029-.058-.029-.087a.107.107,0,0,0-.029-.087c-.029-.116,0-.2.029-.2h.174A2.831,2.831,0,0,1,2209.37,533.481Z",
    transform: "translate(-2204.718 -528.535)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7554",
    "data-name": "Caminho 7554",
    d: "M2209.079,533.954a.791.791,0,0,1-.405.231,5.249,5.249,0,0,1-.463-.81c0-.029-.029-.058-.029-.087s-.029-.058-.029-.087c-.029-.116-.029-.2.029-.2h.174c.289.087.607.636.694.868C2209.05,533.9,2209.079,533.926,2209.079,533.954Z",
    transform: "translate(-2204.63 -528.748)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7555",
    "data-name": "Caminho 7555",
    d: "M2206.787,536.507a4.69,4.69,0,0,1-2.488-.26,11.205,11.205,0,0,0,.376-1.649,7.353,7.353,0,0,0-.058-1.07,2.583,2.583,0,0,0-.144-.694c-.058-.173.086-.289.231-.376a.107.107,0,0,1,.087-.029.223.223,0,0,1,.087-.029h.521a.353.353,0,0,1,.289.173,3.7,3.7,0,0,1,.636,1.678.253.253,0,0,1-.289.26C2206.151,534.916,2206.787,536.507,2206.787,536.507Z",
    transform: "translate(-2201.905 -528.322)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7556",
    "data-name": "Caminho 7556",
    d: "M2208.865,539.416a3.39,3.39,0,0,1-.665-.116,1.343,1.343,0,0,0,.694.318Z",
    transform: "translate(-2204.677 -533.226)",
    fill: "#e0ca7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7557",
    "data-name": "Caminho 7557",
    d: "M2204.6,533.867a9.3,9.3,0,0,1,.145,1.851c-.087.434-.347,1.475-.347,1.475a10.171,10.171,0,0,0,1.1.289,1.162,1.162,0,0,1-.521-.955c.029-.607-.116-2.14-.029-2.69C2204.747,533.491,2204.6,533.867,2204.6,533.867Z",
    transform: "translate(-2201.976 -529.239)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7558",
    "data-name": "Caminho 7558",
    d: "M2200.688,534.859c.173.087.289.231.434.029a8.725,8.725,0,0,0,.839-1.359,2.68,2.68,0,0,1,.145-.289h0a2.521,2.521,0,0,0,.173-.607.278.278,0,0,0-.058-.2.1.1,0,0,1-.058-.029h-.115c-.318.116-.694.723-.694.723s-.578,1.07-.723,1.3C2200.544,534.569,2200.515,534.8,2200.688,534.859Z",
    transform: "translate(-2199.248 -528.322)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7559",
    "data-name": "Caminho 7559",
    d: "M2201,536.92c.116.145.289.231.434.029a8.732,8.732,0,0,0,.839-1.359,2.642,2.642,0,0,1,.145-.289,15.789,15.789,0,0,1-1.157,1.678C2201.2,537.007,2201.116,536.978,2201,536.92Z",
    transform: "translate(-2199.559 -530.383)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7560",
    "data-name": "Caminho 7560",
    d: "M2203.841,532.842a2.3,2.3,0,0,1-.231.983.985.985,0,0,1-.81-.492s.463-.578.781-.665c.029,0,.087-.029.115,0,.029,0,.058,0,.058.029C2203.841,532.639,2203.87,532.726,2203.841,532.842Z",
    transform: "translate(-2200.838 -528.503)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6743",
    "data-name": "Grupo 6743",
    transform: "translate(2.8 4.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7561",
    "data-name": "Caminho 7561",
    d: "M2206.712,532.474a.52.52,0,0,0-.289-.174h-.521a.223.223,0,0,0-.087.029h-.116l.029.029c.058.058.144.116.2.174.058.029.087.087.145.116a3.049,3.049,0,0,0,.347.289c.173.087.289-.087.289-.231A.572.572,0,0,0,2206.712,532.474Z",
    transform: "translate(-2205.7 -532.3)",
    fill: "#dcddf9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7562",
    "data-name": "Caminho 7562",
    d: "M2206.765,530a5.57,5.57,0,0,0,.029.752c-.116.347-.665-.058-.665-.058v-.26c0-.174-.029-.376-.029-.434h.665Z",
    transform: "translate(-2203.184 -526.616)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7563",
    "data-name": "Caminho 7563",
    d: "M2206.623,529.76v.521c-.145.116-.549-.2-.665-.376a2.061,2.061,0,0,0-.058-.405Z",
    transform: "translate(-2203.042 -526.26)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7564",
    "data-name": "Caminho 7564",
    d: "M2206.664,532.438c-.087.2-.521.029-.665-.058-.058-.029-.116.029-.058.058.231.145.723.318.781,0C2206.722,532.438,2206.664,532.41,2206.664,532.438Z",
    transform: "translate(-2203.054 -528.302)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6744",
    "data-name": "Grupo 6744",
    transform: "translate(0.583 1.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7565",
    "data-name": "Caminho 7565",
    d: "M2200.02,522.111c0-.029-.231-.145-.26-.174a.952.952,0,0,0-1.359.521c-.26.9.521,2.14-.347,2.806a.072.072,0,0,0,.029.116.982.982,0,0,0,.579,0,1.417,1.417,0,0,0,.781-1.388c0-.492-.2-1.1.087-1.446a.632.632,0,0,1,.26-.2C2199.991,522.285,2200.194,522.227,2200.02,522.111Z",
    transform: "translate(-2198.034 -521.831)",
    fill: "#e8e8f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6745",
    "data-name": "Grupo 6745",
    transform: "translate(1.168 1.764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7566",
    "data-name": "Caminho 7566",
    d: "M2200.5,525.383a4.946,4.946,0,0,1,0,.926,1.554,1.554,0,0,1-.434.868.04.04,0,0,0,0,.058,1.416,1.416,0,0,0,.781-1.388c0-.492-.2-1.1.087-1.446A1.071,1.071,0,0,0,2200.5,525.383Z",
    transform: "translate(-2200.056 -524.4)",
    fill: "#d2d2ed"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7567",
    "data-name": "Caminho 7567",
    d: "M2207.512,523.8a5.394,5.394,0,0,1,.347,1.1c.058.434-.115.926-.636.955-.173,0-.723-.955-.723-.955Z",
    transform: "translate(-2203.469 -522.209)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7568",
    "data-name": "Caminho 7568",
    d: "M2204.9,524.576a3.688,3.688,0,0,0,.347,1.331,1.093,1.093,0,0,0,.9.376c.376-.058.492-.752.405-1.417C2206.433,524.085,2205.652,523.708,2204.9,524.576Z",
    transform: "translate(-2202.331 -522.407)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7569",
    "data-name": "Caminho 7569",
    d: "M2202.663,522.546h0a.893.893,0,0,1,.347-.434,1.77,1.77,0,0,1,.868-.318c1.331-.058,1.533.868.868.955-.521.058-1.417.116-1.417.116a1.882,1.882,0,0,1,.087.81l-.029-.029a2.653,2.653,0,0,0,.26.665c-.2.174-.723,0-.926-.579A2.27,2.27,0,0,1,2202.663,522.546Z",
    transform: "translate(-2200.701 -520.781)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6746",
    "data-name": "Grupo 6746",
    transform: "translate(2.423 2.674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7570",
    "data-name": "Caminho 7570",
    d: "M2204.8,527.7c-.087-.087-.376-.26-.405-.087-.029.2.318.723.463.463A.3.3,0,0,0,2204.8,527.7Z",
    transform: "translate(-2204.394 -527.543)",
    fill: "#f5f5ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6750",
    "data-name": "Grupo 6750",
    transform: "translate(8.033 1.736)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7572",
    "data-name": "Caminho 7572",
    d: "M2223.464,446.994h-9.545a.328.328,0,0,1-.318-.347c0-.2.087-.347.26-.347h9.545a.328.328,0,0,1,.318.347A.274.274,0,0,1,2223.464,446.994Z",
    transform: "translate(-2213.6 -446.3)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7573",
    "data-name": "Caminho 7573",
    d: "M2229.73,455.294h-14.723a.328.328,0,0,1-.318-.347.285.285,0,0,1,.26-.347h14.723a.328.328,0,0,1,.318.347C2229.99,455.15,2229.9,455.294,2229.73,455.294Z",
    transform: "translate(-2214.371 -452.199)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7574",
    "data-name": "Caminho 7574",
    d: "M2265.024,447.094h-13.306a.328.328,0,0,1-.318-.347c0-.2.087-.347.26-.347h13.305a.348.348,0,0,1,.318.347A.286.286,0,0,1,2265.024,447.094Z",
    transform: "translate(-2240.466 -446.371)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7575",
    "data-name": "Caminho 7575",
    d: "M2284.137,455.294h-5.93a.328.328,0,0,1-.318-.347.286.286,0,0,1,.26-.347h5.929a.348.348,0,0,1,.318.347A.274.274,0,0,1,2284.137,455.294Z",
    transform: "translate(-2259.29 -452.199)",
    fill: "#dcddf9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7576",
    "data-name": "Caminho 7576",
    d: "M2241.427,486.066l-25.28-.029a.991.991,0,0,1-.955-.839l-.607-4.859a.738.738,0,0,1,.752-.839l25.28.029a.991.991,0,0,1,.955.839l.607,4.859A.738.738,0,0,1,2241.427,486.066Z",
    transform: "translate(-2206.261 -468.161)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6751",
    "data-name": "Grupo 6751",
    transform: "translate(9.417 13.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7577",
    "data-name": "Caminho 7577",
    d: "M2228.252,486.194h-9.545a.328.328,0,0,1-.318-.347.286.286,0,0,1,.26-.347h9.545a.328.328,0,0,1,.318.347C2228.512,486.05,2228.4,486.194,2228.252,486.194Z",
    transform: "translate(-2218.385 -485.5)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7578",
    "data-name": "Caminho 7578",
    d: "M2234.441,494.494h-14.723a.328.328,0,0,1-.318-.347c0-.2.087-.347.26-.347h14.723a.328.328,0,0,1,.318.347C2234.7,494.35,2234.615,494.494,2234.441,494.494Z",
    transform: "translate(-2219.106 -491.399)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7579",
    "data-name": "Caminho 7579",
    d: "M2269.813,486.194h-13.305a.328.328,0,0,1-.318-.347.286.286,0,0,1,.26-.347h13.306a.348.348,0,0,1,.318.347C2270.073,486.05,2269.958,486.194,2269.813,486.194Z",
    transform: "translate(-2245.251 -485.5)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7580",
    "data-name": "Caminho 7580",
    d: "M2288.948,494.494h-5.929a.328.328,0,0,1-.318-.347c0-.2.087-.347.26-.347h5.93a.348.348,0,0,1,.318.347C2289.208,494.35,2289.093,494.494,2288.948,494.494Z",
    transform: "translate(-2264.097 -491.399)",
    fill: "#dcddf9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7581",
    "data-name": "Caminho 7581",
    d: "M2245.427,523.466l-25.28-.029a.99.99,0,0,1-.954-.839l-.607-4.859a.738.738,0,0,1,.752-.839l25.28.029a.99.99,0,0,1,.954.839l.607,4.859A.753.753,0,0,1,2245.427,523.466Z",
    transform: "translate(-2209.105 -494.743)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6752",
    "data-name": "Grupo 6752",
    transform: "translate(10.545 23.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7582",
    "data-name": "Caminho 7582",
    d: "M2232.152,523.594h-9.545a.328.328,0,0,1-.318-.347.286.286,0,0,1,.26-.347h9.545a.328.328,0,0,1,.318.347A.286.286,0,0,1,2232.152,523.594Z",
    transform: "translate(-2222.284 -522.9)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7583",
    "data-name": "Caminho 7583",
    d: "M2238.441,531.794h-14.723a.328.328,0,0,1-.318-.347c0-.2.087-.347.26-.347h14.723a.328.328,0,0,1,.318.347C2238.7,531.65,2238.615,531.794,2238.441,531.794Z",
    transform: "translate(-2223.078 -528.728)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7584",
    "data-name": "Caminho 7584",
    d: "M2273.713,523.594h-13.306a.328.328,0,0,1-.318-.347.286.286,0,0,1,.26-.347h13.306a.348.348,0,0,1,.318.347C2273.973,523.45,2273.886,523.594,2273.713,523.594Z",
    transform: "translate(-2249.151 -522.9)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7585",
    "data-name": "Caminho 7585",
    d: "M2292.848,531.894h-5.93a.328.328,0,0,1-.318-.347c0-.2.087-.347.26-.347h5.93a.348.348,0,0,1,.318.347C2293.108,531.75,2293.021,531.894,2292.848,531.894Z",
    transform: "translate(-2267.997 -528.799)",
    fill: "#dcddf9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6759",
    "data-name": "Grupo 6759",
    transform: "translate(3.847 33.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7586",
    "data-name": "Caminho 7586",
    d: "M2205.743,559.9a2.851,2.851,0,0,1-2.892,3.3,3.818,3.818,0,0,1-3.7-3.3,2.865,2.865,0,0,1,2.893-3.3A3.818,3.818,0,0,1,2205.743,559.9Z",
    transform: "translate(-2199.127 -556.6)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7587",
    "data-name": "Caminho 7587",
    d: "M2206.369,560.964a2.47,2.47,0,0,1-2.517,2.864,3.3,3.3,0,0,1-3.21-2.864,2.47,2.47,0,0,1,2.516-2.864A3.3,3.3,0,0,1,2206.369,560.964Z",
    transform: "translate(-2200.188 -557.666)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6758",
    "data-name": "Grupo 6758",
    transform: "translate(0.431 0.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6757",
    "data-name": "Grupo 6757",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7588",
    "data-name": "Caminho 7588",
    d: "M2212.987,572.476c-.174.058.116,1.012,1.359,2.6.318.4.636-.174.492-.4-.174-.26-.868-1.359-.868-1.359S2213.334,572.36,2212.987,572.476Z",
    transform: "translate(-2209.377 -568.311)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7589",
    "data-name": "Caminho 7589",
    d: "M2212.987,572.471c-.174.058.116,1.012,1.359,2.6-.376-.954-.4-1.273-.549-1.678C2213.71,573.107,2213.334,572.355,2212.987,572.471Z",
    transform: "translate(-2209.377 -568.305)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7590",
    "data-name": "Caminho 7590",
    d: "M2213.969,573.281a.779.779,0,0,1-.2.231,1.007,1.007,0,0,1-.434.2,4.208,4.208,0,0,1-.405-.839c0-.029-.029-.058-.029-.087a.106.106,0,0,0-.029-.087c-.029-.116,0-.2.029-.2h.174C2213.478,572.616,2213.969,573.281,2213.969,573.281Z",
    transform: "translate(-2209.318 -568.335)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7591",
    "data-name": "Caminho 7591",
    d: "M2213.779,573.755a.792.792,0,0,1-.405.231,5.3,5.3,0,0,1-.463-.81c0-.029-.029-.058-.029-.087s-.029-.058-.029-.087c-.029-.116-.029-.2.029-.2h.174c.289.087.607.636.694.868A.106.106,0,0,0,2213.779,573.755Z",
    transform: "translate(-2209.301 -568.548)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7592",
    "data-name": "Caminho 7592",
    d: "M2211.488,576.307a4.69,4.69,0,0,1-2.488-.26,11.229,11.229,0,0,0,.376-1.649,7.393,7.393,0,0,0-.058-1.07,2.56,2.56,0,0,0-.145-.694c-.058-.174.087-.289.231-.376a.106.106,0,0,1,.087-.029.224.224,0,0,1,.087-.029h.521a.353.353,0,0,1,.289.174,3.7,3.7,0,0,1,.636,1.678.253.253,0,0,1-.289.26C2210.822,574.717,2211.488,576.307,2211.488,576.307Z",
    transform: "translate(-2206.576 -568.122)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7593",
    "data-name": "Caminho 7593",
    d: "M2213.465,579.216a3.388,3.388,0,0,1-.665-.116,1.343,1.343,0,0,0,.694.318Z",
    transform: "translate(-2209.277 -573.026)",
    fill: "#e0ca7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7594",
    "data-name": "Caminho 7594",
    d: "M2209.2,573.667a9.282,9.282,0,0,1,.145,1.851c-.087.434-.347,1.475-.347,1.475a10.154,10.154,0,0,0,1.1.289,1.161,1.161,0,0,1-.521-.954c.029-.636-.116-2.14-.029-2.69C2209.347,573.291,2209.2,573.667,2209.2,573.667Z",
    transform: "translate(-2206.576 -569.039)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7595",
    "data-name": "Caminho 7595",
    d: "M2205.36,574.659c.173.087.289.231.434.029a8.751,8.751,0,0,0,.839-1.359,2.735,2.735,0,0,1,.145-.289h0a2.513,2.513,0,0,0,.174-.607.278.278,0,0,0-.058-.2.1.1,0,0,1-.058-.029h-.115c-.318.116-.694.723-.694.723s-.579,1.07-.723,1.3C2205.186,574.369,2205.186,574.6,2205.36,574.659Z",
    transform: "translate(-2203.89 -568.122)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7596",
    "data-name": "Caminho 7596",
    d: "M2205.7,576.72c.116.145.289.231.434.029a8.763,8.763,0,0,0,.839-1.36,2.738,2.738,0,0,1,.145-.289,15.715,15.715,0,0,1-1.157,1.678A.3.3,0,0,1,2205.7,576.72Z",
    transform: "translate(-2204.23 -570.183)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7597",
    "data-name": "Caminho 7597",
    d: "M2208.542,572.642a2.294,2.294,0,0,1-.232.983.984.984,0,0,1-.81-.492s.463-.579.781-.665c.029,0,.086-.029.115,0,.029,0,.058,0,.058.029C2208.512,572.44,2208.542,572.526,2208.542,572.642Z",
    transform: "translate(-2205.51 -568.303)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6753",
    "data-name": "Grupo 6753",
    transform: "translate(2.8 4.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7598",
    "data-name": "Caminho 7598",
    d: "M2211.313,572.274a.518.518,0,0,0-.289-.174h-.521a.224.224,0,0,0-.087.029h-.116l.029.029c.058.058.145.116.2.174.058.029.087.087.144.116a3.092,3.092,0,0,0,.347.289c.174.087.289-.087.289-.231C2211.341,572.5,2211.341,572.389,2211.313,572.274Z",
    transform: "translate(-2210.3 -572.1)",
    fill: "#dcddf9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7599",
    "data-name": "Caminho 7599",
    d: "M2211.465,569.8a5.569,5.569,0,0,0,.029.752c-.116.347-.665-.058-.665-.058v-.26c0-.174-.029-.376-.029-.434h.665Z",
    transform: "translate(-2207.855 -566.416)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7600",
    "data-name": "Caminho 7600",
    d: "M2211.323,569.56v.521c-.145.116-.55-.2-.665-.376a2.053,2.053,0,0,0-.058-.405Z",
    transform: "translate(-2207.713 -566.06)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7601",
    "data-name": "Caminho 7601",
    d: "M2211.264,572.239c-.087.2-.521.029-.665-.058-.058-.029-.116.029-.058.058.232.145.723.318.781,0C2211.351,572.239,2211.293,572.21,2211.264,572.239Z",
    transform: "translate(-2207.654 -568.102)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6754",
    "data-name": "Grupo 6754",
    transform: "translate(0.612 1.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7602",
    "data-name": "Caminho 7602",
    d: "M2204.72,561.911c0-.029-.231-.145-.26-.174a.952.952,0,0,0-1.36.521c-.26.9.521,2.169-.347,2.806a.071.071,0,0,0,.029.116.98.98,0,0,0,.579,0,1.416,1.416,0,0,0,.781-1.388c0-.492-.2-1.1.087-1.446a.63.63,0,0,1,.26-.2C2204.663,562.085,2204.865,562.027,2204.72,561.911Z",
    transform: "translate(-2202.735 -561.631)",
    fill: "#e8e8f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6755",
    "data-name": "Grupo 6755",
    transform: "translate(1.197 1.764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7603",
    "data-name": "Caminho 7603",
    d: "M2205.2,565.184a4.946,4.946,0,0,1,0,.926,1.556,1.556,0,0,1-.434.868.04.04,0,0,0,0,.058,1.417,1.417,0,0,0,.781-1.388c0-.492-.2-1.1.086-1.446A1.012,1.012,0,0,0,2205.2,565.184Z",
    transform: "translate(-2204.756 -564.2)",
    fill: "#d2d2ed"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7604",
    "data-name": "Caminho 7604",
    d: "M2212.212,563.6a5.437,5.437,0,0,1,.347,1.1c.058.434-.115.926-.636.954-.173,0-.723-.954-.723-.954Z",
    transform: "translate(-2208.139 -562.009)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7605",
    "data-name": "Caminho 7605",
    d: "M2209.5,564.407a3.683,3.683,0,0,0,.347,1.331,1.093,1.093,0,0,0,.9.376c.376-.058.492-.752.405-1.417C2211.062,563.915,2210.252,563.568,2209.5,564.407Z",
    transform: "translate(-2206.931 -562.237)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7606",
    "data-name": "Caminho 7606",
    d: "M2207.314,562.346h0a.893.893,0,0,1,.347-.434,1.769,1.769,0,0,1,.868-.318c1.331-.058,1.533.868.868.954-.521.058-1.417.116-1.417.116a1.877,1.877,0,0,1,.087.81l-.029-.029a2.642,2.642,0,0,0,.26.665c-.2.174-.723,0-.926-.578A1.8,1.8,0,0,1,2207.314,562.346Z",
    transform: "translate(-2205.324 -560.581)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6756",
    "data-name": "Grupo 6756",
    transform: "translate(2.452 2.674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7607",
    "data-name": "Caminho 7607",
    d: "M2209.5,567.5c-.087-.087-.376-.26-.4-.087-.029.231.318.723.462.463A.413.413,0,0,0,2209.5,567.5Z",
    transform: "translate(-2209.094 -567.343)",
    fill: "#f5f5ff"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7609",
    "data-name": "Caminho 7609",
    d: "M2250.027,563.266l-25.28-.029a.991.991,0,0,1-.955-.839l-.607-4.859a.738.738,0,0,1,.752-.839l25.28.029a.991.991,0,0,1,.955.839l.607,4.859A.738.738,0,0,1,2250.027,563.266Z",
    transform: "translate(-2212.375 -523.031)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6760",
    "data-name": "Grupo 6760",
    transform: "translate(11.909 35.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7610",
    "data-name": "Caminho 7610",
    d: "M2236.863,563.394h-9.545a.348.348,0,0,1-.318-.347c0-.2.087-.347.26-.347h9.545a.328.328,0,0,1,.318.347C2237.124,563.221,2237.008,563.394,2236.863,563.394Z",
    transform: "translate(-2227 -562.7)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7611",
    "data-name": "Caminho 7611",
    d: "M2243.13,571.694h-14.723a.328.328,0,0,1-.318-.347.285.285,0,0,1,.26-.347h14.723a.328.328,0,0,1,.318.347C2243.39,571.521,2243.275,571.694,2243.13,571.694Z",
    transform: "translate(-2227.771 -568.599)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7612",
    "data-name": "Caminho 7612",
    d: "M2278.424,563.394h-13.305a.328.328,0,0,1-.318-.347c0-.2.087-.347.26-.347h13.305a.348.348,0,0,1,.318.347C2278.684,563.25,2278.568,563.394,2278.424,563.394Z",
    transform: "translate(-2253.866 -562.7)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7613",
    "data-name": "Caminho 7613",
    d: "M2297.548,571.694h-5.93a.328.328,0,0,1-.318-.347c0-.2.087-.347.26-.347h5.929a.348.348,0,0,1,.318.347C2297.808,571.55,2297.692,571.694,2297.548,571.694Z",
    transform: "translate(-2272.701 -568.599)",
    fill: "#dcddf9"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7614",
    "data-name": "Caminho 7614",
    d: "M2224.62,423.664c0,2.083-.521,3.471-1.62,3.934l-1.823.752h0c-1.07.4-2.545-.116-4.281-1.359-10.066-2.516-21.2-.723-30.371,2l.347.781,1.62-.55,1.822,4.021,3.384,3.5-.694.231-2.43.81,11.252,24.008a1.548,1.548,0,0,1-.839,2.2l-6.74,2.227-2.777.926a2.013,2.013,0,0,1-2.343-1.128l-15.041-32.338c-3.645,1.562-6.016,2.748-6.479,2.979a.355.355,0,0,0-.087.058h0a14.658,14.658,0,0,1-3.963-3.876,8.912,8.912,0,0,1-8.5-7.318,6.551,6.551,0,0,1,1.475-5.5,21.649,21.649,0,0,1-1.128-4.426c-.058-.289-.115-.521-.145-.694h67.626A30.132,30.132,0,0,1,2224.62,423.664Z",
    transform: "translate(-15.464 -187.276)",
    fill: "#1b0976",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6767",
    "data-name": "Grupo 6767",
    transform: "translate(2163.889 188.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6766",
    "data-name": "Grupo 6766",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6763",
    "data-name": "Grupo 6763",
    transform: "translate(16.776 44.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7615",
    "data-name": "Caminho 7615",
    d: "M2321.047,471.778l-9.95,3.153a1.733,1.733,0,0,1-2.169-1.128L2297.3,437.994l13.277-4.194,11.628,35.809A1.787,1.787,0,0,1,2321.047,471.778Z",
    transform: "translate(-2297.3 -433.8)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7616",
    "data-name": "Caminho 7616",
    d: "M2350.513,452.32l-4.4,1.359-2.516-8.012,2.748-.868,1.273,4.021Z",
    transform: "translate(-2330.208 -441.618)",
    fill: "#d6695d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7617",
    "data-name": "Caminho 7617",
    d: "M2348.013,453.092l-4.4,1.388-2.517-8.012,2.777-.868,1.244,3.992Z",
    transform: "translate(-2328.431 -442.187)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7618",
    "data-name": "Caminho 7618",
    d: "M2313.99,480.758l-2.893.926a1.733,1.733,0,0,1-2.169-1.128L2297.3,444.746l4.57-1.446Z",
    transform: "translate(-2297.3 -440.552)",
    fill: "#312da4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_653",
    "data-name": "Elipse 653",
    cx: 7.492,
    cy: 7.492,
    r: 7.492,
    transform: "translate(0 36.198)",
    fill: "#312da4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7619",
    "data-name": "Caminho 7619",
    d: "M2290,294.6s-12.235,19.669-44.4,28.665c0,0,.463,14.781,9.053,22.272,0,0,33.437-17.3,54.813-8.359Z",
    transform: "translate(-2243.778 -290.48)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7620",
    "data-name": "Caminho 7620",
    d: "M2246.2,401.1c.029.231.058.463.087.723C2246.258,401.563,2246.229,401.331,2246.2,401.1Z",
    transform: "translate(-2244.204 -366.175)",
    fill: "#7c71ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7621",
    "data-name": "Caminho 7621",
    d: "M2285.479,376.9c-.983.434-1.967.839-2.979,1.244C2283.512,377.739,2284.525,377.3,2285.479,376.9Z",
    transform: "translate(-2270.004 -348.975)",
    fill: "#7c71ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7622",
    "data-name": "Caminho 7622",
    d: "M2295.664,372.4q-1.388.651-2.864,1.3,1.475-.651,2.864-1.3Z",
    transform: "translate(-2277.325 -345.776)",
    fill: "#7c71ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7623",
    "data-name": "Caminho 7623",
    d: "M2270.42,394.441a157.585,157.585,0,0,0-16,6.392c-3.789-2.083-9.979-15.706-9.053-22.272a117.584,117.584,0,0,0,16.516-6.161C2263.3,381.338,2268.569,391.548,2270.42,394.441Z",
    transform: "translate(-2243.549 -345.776)",
    fill: "#d6695d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6765",
    "data-name": "Grupo 6765",
    transform: "translate(45.663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7624",
    "data-name": "Caminho 7624",
    d: "M2415.2,301.8c-4.049-10.442-9.545-18.454-13.479-20.1l-.347-.9-1.938.752h0c-3.7,1.533-2.777,12.929,2.112,25.541s11.888,21.636,15.677,20.276h0l1.938-.752-.347-.9C2420.576,321.873,2419.246,312.241,2415.2,301.8Z",
    transform: "translate(-2397.166 -280.671)",
    fill: "#feae59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7625",
    "data-name": "Caminho 7625",
    d: "M2421.618,300.76c4.917,12.669,5.843,24.094,2.054,25.57-2.979,1.157-7.954-4.223-12.351-12.727a79.239,79.239,0,0,1-3.384-7.52,76.737,76.737,0,0,1-2.574-7.81c-2.516-9.256-2.458-16.6.521-17.76C2409.672,279.038,2416.73,288.091,2421.618,300.76Z",
    transform: "translate(-2401.708 -280.356)",
    fill: "#d6695d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6764",
    "data-name": "Grupo 6764",
    transform: "translate(3.683 14.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7626",
    "data-name": "Caminho 7626",
    d: "M2422.425,348.282a10.731,10.731,0,0,0-6.566,2.14,79.185,79.185,0,0,1-3.384-7.52,76.674,76.674,0,0,1-2.574-7.81,9.666,9.666,0,0,0,6.277-2.892C2420.139,333.935,2424.594,344.551,2422.425,348.282Z",
    transform: "translate(-2409.9 -331.31)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_654",
    "data-name": "Elipse 654",
    cx: 2.574,
    cy: 8.62,
    rx: 2.574,
    ry: 8.62,
    transform: "translate(3.891 1.862) rotate(-21.205)",
    fill: "#312da4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7627",
    "data-name": "Caminho 7627",
    d: "M2438.535,348.7c.926,2.43,1.128,4.6.4,4.888s-2.082-1.446-3.008-3.876-1.128-4.6-.4-4.888S2437.581,346.269,2438.535,348.7Z",
    transform: "translate(-2427.804 -340.259)",
    fill: "url(#linear-gradient-18)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7628",
    "data-name": "Caminho 7628",
    d: "M2245.1,324.089s.029.81.174,2.14c.029.231.058.463.087.723.029.116.029.26.058.376a1.946,1.946,0,0,0,.058.4,6.9,6.9,0,0,0,.115.694,45.906,45.906,0,0,0,1.07,4.859c.087.289.174.607.26.9.058.145.087.289.145.463a4.147,4.147,0,0,0,.145.463c.058.145.087.318.145.463s.116.318.174.463a156.837,156.837,0,0,0,17.933-5.582,129.795,129.795,0,0,0,27.565-13.884c-3.153-8.5-4.483-16.343-3.731-20.768-1.186,2.054-8.128,12.958-27.681,22.156q-1.389.651-2.864,1.3c-.983.434-1.967.839-2.979,1.244-.665.26-1.359.521-2.053.781-.665.231-1.331.492-2,.723-.058.029-.116.029-.174.058-.549.2-1.128.4-1.678.578-.231.087-.463.145-.665.231-.607.2-1.244.4-1.88.578C2246.575,323.655,2245.852,323.886,2245.1,324.089Z",
    transform: "translate(-2243.422 -291.333)",
    fill: "#fff",
    opacity: 0.21
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6774",
    "data-name": "Grupo 6774",
    transform: "translate(2192.986 154.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7629",
    "data-name": "Caminho 7629",
    d: "M2363.444,308.58l.723-.723c-.347-5.9-1.273-8.128-1.273-8.157l-.694.145A38.072,38.072,0,0,1,2363.444,308.58Z",
    transform: "translate(-2355.748 -259.61)",
    fill: "#312da4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6768",
    "data-name": "Grupo 6768",
    transform: "translate(6.799 0.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7630",
    "data-name": "Caminho 7630",
    d: "M2366.032,161.345l-1.1,18.252-.376,6.016-1.157-.058.174-2.835.174-3.153.058-1.012,1.041-17.355C2365.251,161.258,2365.627,161.287,2366.032,161.345Z",
    transform: "translate(-2363.4 -161.2)",
    fill: "#312da4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6769",
    "data-name": "Grupo 6769",
    transform: "translate(1.593 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7631",
    "data-name": "Caminho 7631",
    d: "M2347.917,185.8l-1.157.058-.347-6.335-1.012-18.338c.347-.029.752-.058,1.157-.087l.954,17.471.058.955.174,3.095Z",
    transform: "translate(-2345.4 -161.1)",
    fill: "#312da4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6770",
    "data-name": "Grupo 6770",
    transform: "translate(2.865 16.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7632",
    "data-name": "Caminho 7632",
    d: "M2352.432,219a2.632,2.632,0,1,0,2.632,2.632A2.642,2.642,0,0,0,2352.432,219Z",
    transform: "translate(-2349.8 -219)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7633",
    "data-name": "Caminho 7633",
    d: "M2356.7,225a.9.9,0,1,0,.9.9A.9.9,0,0,0,2356.7,225Z",
    transform: "translate(-2354.064 -223.265)",
    fill: "#769375"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6773",
    "data-name": "Grupo 6773",
    transform: "translate(0 18.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6771",
    "data-name": "Grupo 6771",
    transform: "translate(1.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7634",
    "data-name": "Caminho 7634",
    d: "M2346.907,224.8h8.533a.642.642,0,0,1,.636.636v8.475a1.9,1.9,0,0,1-.405,1.1l-1.649,1.88a1.573,1.573,0,0,1-1.041.463H2349.4a1.573,1.573,0,0,1-1.041-.463l-1.649-1.88a1.9,1.9,0,0,1-.405-1.1v-8.475A.6.6,0,0,1,2346.907,224.8Z",
    transform: "translate(-2346.3 -224.8)",
    fill: "#cf3b59"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7635",
    "data-name": "Caminho 7635",
    d: "M2342.02,267.854h0a4.156,4.156,0,0,1,.578-.4,5.313,5.313,0,0,0,1.591-1.62V263.4h2.922v2.459a6.047,6.047,0,0,1-1.1,2.6c-1.678,1.938-1.851,2.083-1.851,2.632a1.638,1.638,0,0,0,1.562,1.678,1.772,1.772,0,0,0,1.649-1.649,3.225,3.225,0,0,1,1.591-2.516c.434-.058.983-.058.549.463a2.925,2.925,0,0,0-.607,2.054v.058a4.252,4.252,0,1,1-6.884-3.326Z",
    transform: "translate(-2340.253 -252.235)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6772",
    "data-name": "Grupo 6772"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7636",
    "data-name": "Caminho 7636",
    d: "M2340.5,224.8h8.533a.642.642,0,0,1,.636.636v8.475a1.9,1.9,0,0,1-.405,1.1l-1.649,1.88a1.573,1.573,0,0,1-1.041.463h-3.586a1.573,1.573,0,0,1-1.042-.463l-1.649-1.88a1.9,1.9,0,0,1-.405-1.1v-8.475A.585.585,0,0,1,2340.5,224.8Z",
    transform: "translate(-2339.893 -224.8)",
    fill: "url(#linear-gradient-21)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7637",
    "data-name": "Caminho 7637",
    d: "M2355.4,333.244a9.4,9.4,0,0,0,.521,2.4c.26.578.579.926.983,1.012a1.188,1.188,0,0,0,.318.029c.752-.058,1.128-.665,1.5-1.591l-.752.2a.864.864,0,0,1-.9.694c-.087,0-.232-.087-.376-.4a6.765,6.765,0,0,1-.578-2.4c-.636-5.611-1.388-24.7-1.244-31.76.029-2,.087-3.7.145-4.975a18.912,18.912,0,0,1,.174-2.256.151.151,0,0,1,.058-.116c.058-.116.116-.2.2-.231a.768.768,0,0,1,.549.116h0c.058-.029.087-.058.145-.087a.028.028,0,0,0,.029-.029c.029-.029.087-.058.116-.087.058-.058.116-.087.174-.145.029-.058.086-.087.115-.145a1.884,1.884,0,0,0-1.388-.289,1.1,1.1,0,0,0-.636.665c-.029.058-.029.116-.058.174a17.09,17.09,0,0,0-.174,2.14c-.058,1.331-.116,3.182-.174,5.351C2354.011,308.571,2354.763,327.661,2355.4,333.244Z",
    transform: "translate(-2350.017 -254.944)",
    fill: "#312da4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6777",
    "data-name": "Grupo 6777",
    transform: "translate(2235.276 164.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7638",
    "data-name": "Caminho 7638",
    d: "M2531.231,165.836h0l-.024-.024-.047-.047-1.065-1.065-.024.568h-36.625a1.849,1.849,0,0,0-1.846,1.847v33.618a1.849,1.849,0,0,0,1.846,1.847h3.172l-3.693,5.824,1.278,1.255,10.109-7.079h25.569a1.849,1.849,0,0,0,1.847-1.847V167.115A2.126,2.126,0,0,0,2531.231,165.836Z",
    transform: "translate(-2490.298 -163.966)",
    fill: "#8fabec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6775",
    "data-name": "Grupo 6775"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7639",
    "data-name": "Caminho 7639",
    d: "M2524.382,198.911h-36.435a1.849,1.849,0,0,1-1.847-1.847V163.447a1.849,1.849,0,0,1,1.847-1.847h36.435a1.849,1.849,0,0,1,1.847,1.847v33.618A1.849,1.849,0,0,1,2524.382,198.911Z",
    transform: "translate(-2486.1 -161.6)",
    fill: "#becef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7640",
    "data-name": "Caminho 7640",
    d: "M2499.681,314.576,2497.1,322.1l11.364-8.4Z",
    transform: "translate(-2494.496 -277.691)",
    fill: "#becef5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6776",
    "data-name": "Grupo 6776",
    transform: "translate(2.865 2.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7641",
    "data-name": "Caminho 7641",
    d: "M2532.41,174.243l.048,27.344a2.37,2.37,0,0,1-2.344,2.367l-29.5.047a2.369,2.369,0,0,1-2.367-2.344l-.047-27.344a2.369,2.369,0,0,1,2.344-2.367l29.5-.047A2.324,2.324,0,0,1,2532.41,174.243Z",
    transform: "translate(-2498.2 -171.898)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7642",
    "data-name": "Caminho 7642",
    d: "M2532.586,225.382l.023,13.518a2.37,2.37,0,0,1-2.344,2.367l-29.5.047a2.369,2.369,0,0,1-2.367-2.344v-3.835l5.114-5.729a1.124,1.124,0,0,1,1.657-.024l6.795,7.008a1.117,1.117,0,0,0,1.634-.024l13.9-15.223a1.142,1.142,0,0,1,1.7.047Z",
    transform: "translate(-2498.353 -209.212)",
    fill: "#8fabec"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_655",
    "data-name": "Elipse 655",
    cx: 4.119,
    cy: 4.119,
    r: 4.119,
    transform: "translate(6.226 4.167)",
    fill: "#8fabec"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7643",
    "data-name": "Caminho 7643",
    d: "M2290.06,638.878H2133.489a.289.289,0,0,1,0-.578H2290.06a.289.289,0,0,1,0,.578Z",
    transform: "translate(0 -346.058)",
    fill: "#4d4d4d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignwillbeinterrupted);
export default __webpack_public_path__ + "static/media/Campaign will be interrupted.3e3b5cdb.svg";
export { ForwardRef as ReactComponent };